module.exports = __webpack_public_path__ + "img/vindressurser.0c3ea10e.jpg";